import {Row} from 'react-table'

type Props<T extends object> = {
  row: Row<T>;
};

export const TableRow = <T extends object>({ row }: Props<T>) => {
  // 1. Extract row key separately to avoid key-spread warnings on <tr>
  const { key: rowKey, ...restRowProps } = row.getRowProps();  

  return (
  <tr key={rowKey} {...restRowProps}>
    {row.cells.map((cell) => {
      // 2. Extract cell key separately for <td>
      const { key: cellKey, ...restCellProps } = cell.getCellProps();        
      return (
        <td 
          key={cellKey} 
          {...restCellProps}            
        >
          {cell.render('Cell')}
        </td>
      );
    })}
  </tr>
  );
};